import type { GetTweetById200Content } from './getTweetById200Content';
import type { GetTweetById200MediaItem } from './getTweetById200MediaItem';
import type { GetTweetById200Poll } from './getTweetById200Poll';
import type { GetTweetById200Stats } from './getTweetById200Stats';
import type { GetTweetById200Tags } from './getTweetById200Tags';
import type { GetTweetById200TweetType } from './getTweetById200TweetType';

export type GetTweetById200 = {
  authorDisplayName?: string;
  authorId?: string;
  authorProfileImageUrl?: string;
  authorUsername?: string;
  content?: GetTweetById200Content;
  createdAt?: string;
  isLiked?: boolean;
  isRetweeted?: boolean;
  media?: GetTweetById200MediaItem[];
  poll?: GetTweetById200Poll;
  /**
   * ID of the referenced tweet (for replies and quotes)
   * @nullable
   */
  referencedTweetId?: string | null;
  stats?: GetTweetById200Stats;
  tags?: GetTweetById200Tags;
  tweetId?: string;
  /** Type of tweet */
  tweetType?: GetTweetById200TweetType;
  updatedAt?: string;
};
